export default class Event {
  constructor(
    id,
    title,
    previewTitle,
    description,
    dateOfEvent,
    dateOfCreate,
    imageURL,
    linkURL,
    likesCount = 0,
    possibleParticipants = [],
    companyID,
    cityID,
    companyName = null,
    companyLogoURL = null,
    companyAbout = null,       
    companySpecifics = null,   
    participants = [],
    isEnded = false,
    isOurEvent = false 
  ) {
    this.id = id;
    this.title = title;
    this.previewTitle = previewTitle;
    this.description = description;
    this.dateOfEvent = dateOfEvent;
    this.dateOfCreate = dateOfCreate;
    this.imageURL = imageURL;
    this.linkURL = linkURL;
    this.likesCount = likesCount;
    this.possibleParticipants = possibleParticipants;
    this.companyID = companyID;
    this.cityID = cityID;

    this.companyName = companyName;
    this.companyLogoURL = companyLogoURL;
    this.companyAbout = companyAbout;            
    this.companySpecifics = companySpecifics;    

    this.participants = participants;
    this.isEnded = isEnded;
    this.isOurEvent = isOurEvent; 
  }

  static fromJson(json) {
    return new Event(
      json.id,
      json.title,
      json.preview_title,
      json.description,
      json.date_of_event,
      json.date_of_create,
      json.image_url,
      json.link_url,
      json.likes_count || 0,
      json.possible_participants || [],
      json.company_id,
      json.city_id,
      json.name || null,                 
      json.logo || null,                 
      json.about || null,            
      json.specifics || null,          
      json.participants || [],
      json.is_ended || false,
      json.is_our_event || false  
    );
  }
}